module.exports = __webpack_public_path__ + "static/pic01-e1c133ea6ed3da41068f5d6a5b56fdb5.jpg";